import React from 'react'
import {
    StyledButton,
    StyledTNPromoBannerContainer,
    StyledHeading,
    StyledTextContainer,
    StyledTheNightlyLogo,
} from './TNPromoBanner.styled'
export interface TNPromoBannerProps {}

export const TNPromoBanner: React.FC<TNPromoBannerProps> = () => (
    <StyledTNPromoBannerContainer>
        <StyledTheNightlyLogo logoWidth={208} logoHeight={24} />
        <StyledHeading>Get in front of tomorrow's news for FREE</StyledHeading>
        <StyledTextContainer>
            <p>
                Journalism for the curious Australian across politics, business,
                culture and opinion.
            </p>
            <StyledButton to={'https://thenightly.com.au/'}>
                READ NOW
            </StyledButton>
        </StyledTextContainer>
    </StyledTNPromoBannerContainer>
)
